module.exports = __webpack_public_path__ + "img/FEMEA_12.44a96e6c.jpeg";